<h2 mat-dialog-title>Do you need to add mileage or an expense?</h2>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">No</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>